const _wzEnv_ = window._wzEnv_ || {}
export function getBaseDir() {
  return _wzEnv_.appDir || '/'
}

// export function goHome(url, replace) {
//   url = url || `https://${HOST_WEB}`
//   if (replace === true) {
//     location.replace(url)
//   } else {
//     location.href = url
//   }
// }

// export function goBack(url) {
//   history.length > 1 ? history.go(-1) : goHome(url, true)
// }
